import { Button } from "@design";
import { useQuery } from "@tanstack/react-query";
import { Lock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getPersonalSpaceOptions } from "@/api";
import { Page } from "@/components/Page";
import { Text } from "@/components/Text";
import { useCurrentUser } from "@/features/account/useCurrentUser";
import { dayPart, firstName } from "./greeting";
import { HomeAsk } from "./HomeAsk";
import { NeedsAttention, RecentChats, SpacesActivityFeed } from "./HomeSections";
import { PinnedAgents } from "./PinnedAgents";

export function HomePage() {
  const { t } = useTranslation(["home", "common"]);
  const navigate = useNavigate();
  const me = useCurrentUser();
  const personal = useQuery({ ...getPersonalSpaceOptions(), select: (r) => r.data });
  const name = firstName(me.data?.user.name);
  const part = dayPart();

  return (
    <Page
      title={name ? t(`greeting.${part}`, { name }) : t(`greeting.${part}Anon`)}
      subtitle={t("subtitle")}
      actions={
        personal.data && (
          <Button
            variant="secondary"
            size="sm"
            leadingIcon={<Lock size={14} />}
            onClick={() => navigate(`/spaces/${personal.data.uuid}`)}
          >
            {t("privateSpace")}
          </Button>
        )
      }
    >
      {me.isError && (
        <Text tone="error" role="alert">
          {t("common:errors.profileLoad")}
        </Text>
      )}
      <HomeAsk />
      <PinnedAgents />
      <div className="grid grid-cols-1 gap-x-6 gap-y-7 lg:grid-cols-2">
        <NeedsAttention />
        <RecentChats />
        <SpacesActivityFeed />
      </div>
    </Page>
  );
}
